import { Injectable } from '@angular/core';
import { BaseService } from '../base/util/base.service';
import { HttpClient } from '@angular/common/http';

import { MessageService } from 'primeng/components/common/messageservice';
import { popupMensagem } from '../base/util/url-util';
import { popupAlvo } from '../base/util/url-util';

@Injectable()
export class PopupService extends BaseService {

    control = false;

    constructor(
        public http: HttpClient,
        public messageService: MessageService) {
        super(http, messageService);
    }

    getMensagem() {
        return this.get(popupMensagem());
    }

    getAlvo(username: string) {
        return this.get(popupAlvo(username));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/popup/popup.service.ts